module.exports = __webpack_public_path__ + "static/media/DLMS-Logo-Vector-2021-250x80.5419e781.png";